import { Form, Formik, FormikHelpers } from "formik";
import { Row } from "reactstrap";
import styles from "src/components/Common/UI/MultiStepWizard/MultiStepWizard.module.css";
import * as Yup from "yup";
import UnitsSelectionDropdown from "src/components/Common/UI/UnitsSelectionDropdown/UnitsSelectionDropdown";


const EstablishmentUnitForm: React.FC<StepProps> = ({
  initialValues,
  onSubmit
}) => {
    
  const WizardSchema = Yup.object().shape({
    unitID: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
  });

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={WizardSchema}
        onSubmit={onSubmit}
        enableReinitialize={true}
      >
        {({ errors, touched }) => (
          <Form>
          <Row>
            <UnitsSelectionDropdown errors={errors} touched={touched} unitType={initialValues.unitType}/>
          </Row>
            <button type="submit" className={styles.buttonnext}>
              Συνέχεια
            </button>
          </Form>
        )}
      </Formik>
    </>
  );
};

interface StepProps {
  type: "create" | "edit";
  initialValues: IEstablishmentUnitForm;
  onSubmit: (
    values: IEstablishmentUnitForm,
    formikHelpers: FormikHelpers<IEstablishmentUnitForm>
  ) => void;
}

export default EstablishmentUnitForm;
